import qs from "qs";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { t } from "@/i18n-js/instance";
import { useRouterQueryParams } from "@circle-react/hooks/useRouterQueryParamsV2";
import { DebouncedSearchBar } from "@circle-react-shared/DebouncedSearchBar";
import { IconButton } from "@circle-react-shared/uikit/HeaderV3/IconButton";

interface MembersSearchProps {
  setShouldRenderMobileFiltersTransition: React.Dispatch<
    React.SetStateAction<boolean>
  >;
}

const queryParamSchema = yup.object({
  filter: yup.object({
    name: yup.string().optional(),
  }),
});

export const MembersSearch = ({
  setShouldRenderMobileFiltersTransition,
}: MembersSearchProps) => {
  const history = useHistory();
  const queryParams = useRouterQueryParams(queryParamSchema);

  const onSubmit = (value: string) =>
    history.push({
      search: qs.stringify(
        {
          ...queryParams,
          filter: {
            ...queryParams?.filter,
            name: value?.trim(),
          },
        },
        { encode: false },
      ),
    });

  return (
    <div className="bg-primary border-primary flex items-center justify-between border-b px-4 py-2 md:hidden">
      <DebouncedSearchBar
        defaultValue={queryParams?.filter?.name}
        onSearch={onSubmit}
        placeholder={t("members_directory.header.search.placeholder")}
      />
      <IconButton
        ariaLabel={t("members_directory.header.search.filters")}
        name="20-filters"
        iconSize={20}
        iconClassName="!text-dark"
        buttonSize={28}
        onClick={() =>
          setShouldRenderMobileFiltersTransition(prevState => !prevState)
        }
      />
    </div>
  );
};
